import React, { useContext } from 'react';
import Select from 'react-select';
import { TranslationContext } from "./Context";

function DropDown(props) {
    const translation = useContext(TranslationContext);

    const disabled = function() {
        if (props.options) {
            return props.options.length < 1;
        }
        else return true;
    };

    return (
        <div className="form-group">
            <label className="u-textSemi16 u-block" htmlFor={props.id}>{props.label}</label>
            <Select isClearable={props.isClearable && props.isClearable === true} className="text-left" id={props.id} options={props.options} placeholder={<div>{translation["TecAlliencePartSearch.Shared.Select"]}</div>} noOptionsMessage={() => { translation["TecAlliencePartSearch.Shared.NoOptions"] }} onChange={props.onChange} isDisabled={disabled()} value={props.value} />
        </div>
    );
}

export default DropDown;